import { Roles } from "@outschool/auth-shared";
import { FullCurrentUserFragmentFragment } from "@outschool/gql-frontend-generated";

export function isOrganizationAdmin(
  user: FullCurrentUserFragmentFragment | null,
): boolean {
  return Boolean(user?.organizationAdmin);
}

export function isOrganizationAdminWhoCanEnroll(
  user: FullCurrentUserFragmentFragment | null, //This is not necessary currentUser
): boolean {
  return Boolean(
    user?.organizationAdmin &&
      user?.roles?.includes(Roles.CanOrganizationEnroll),
  );
}
